import { A } from '../actions/items';
import update from 'immutability-helper';

const initialState = {
  getItems: {
    isFetching: false,
    error: null,
  },
  getItemById: {
    isFetching: false,
    error: null,
  },
  addItem: {
    isFetching: false,
    error: null,
  },
  addImage: {
    isFetching: false,
    error: null,
  },
  reorderImage: {
    isFetching: false,
    error: null,
  },
  deleteImage: {
    isFetching: false,
    error: null,
  },
  generateVariants: {
    isFetching: false,
    error: null,
  },
  editVariant: {
    isFetching: false,
    error: null,
  },
  deleteVariant: {
    isFetching: false,
    error: null,
  },
  editItem: {
    isFetching: false,
    error: null,
  },
  copyItem: {
    isFetching: false,
    error: null,
  },
  archiveItem: {
    isFetching: false,
    error: null,
  },
  restoreItem: {
    isFetching: false,
    error: null,
  },
  hideShowItem: {
    isFetching: false,
    error: null,
  },
  getFeatures: {
    isFetching: false,
    error: null,
  },
  features: [],
  addFeature: {
    isFetching: false,
    error: null,
  },
  getAttributes: {
    isFetching: false,
    error: null,
  },
  addAccountingAttribute: {
    isFetching: false,
    error: null,
  },
  getAccountingAttributes: {
    isFetching: false,
    error: null,
  },
  addAttribute: {
    isFetching: false,
    error: null,
  },
  getAdditionalDescs: {
    isFetching: false,
    error: null,
  },
  exportItemsToFulfillment: {
    isFetching: false,
    error: null,
  },
  getProductAppearance: {
    isFetching: false,
    error: null,
  },
  updateProductAppearance: {
    isFetching: false,
    error: null,
  },
  getProductReviews: {
    isFetching: false,
    error: null,
  },
  updateProductReview: {
    isFetching: false,
    error: null,
  },
  getSubscriptionData: {
    isFetching: false,
    error: null,
  },
  importSubscriptionData: {
    isFetching: false,
    error: null,
  },
  getSKUSets: {
    isFetching: false,
    error: null,
  },
  updatePhysicalSet: {
    isFetching: false,
    error: null,
  },
  updateSKUSet: {
    isFetching: false,
    error: null,
  },
  getPhysicalSetOrders: {
    isFetching: false,
    error: null,
  },
  updatePhysicalSetOrder: {
    isFetching: false,
    error: null,
  },
  copyPhysicalSetOrder: {
    isFetching: false,
    error: null,
  },
  cancelPhysicalSetOrder: {
    isFetching: false,
    error: null,
  },
  getEshops: {
    isFetching: false,
    error: null,
  },
  getProductHistory: {
    isFetching: false,
    error: null,
  },
  productsDifHistory: {
    isFetching: false,
    error: null,
  },
  productsBatchAccountingStocks: {
    isFetching: false,
    error: null,
  },
  productsWarehouseCategories: {
    isFetching: false,
    error: null,
  },
  getProductsPriceMarginHistory: {
    isFetching: false,
    error: null,
  },
  getProductMargin: {
    isFetching: { $set: false },
  },
  getProductMarginShipped: {
    isFetching: { $set: false },
  },
  getProductMarginDelivered: {
    isFetching: { $set: false },
  },
  productMarginShipped: null,
  productMarginDelivered: null,
  data: [],
  productHistory: [],
  archive: [],
  importChestnyznakUniqNumbersExcel: {
    isFetching: { $set: false },
  },
  getStatisticsOfUsingChestnyznak: {
    isFetching: { $set: false },
  },
  statisticsOfUsingChestnyznak: null,
  getUnloadingSetOfGoodsChestnyznak: {
    isFetching: false,
    error: null,
  },
  stockByDate: null,
  getStockByDate: {
    isFetching: { $set: false },
  },
  commonMaterial: null,
  getCommonMaterials: {
    isFetching: { $set: false },
  },

  physicalSetOrders: null,
};

const items = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_GET_ITEMS:
      return update(state, {
        getItems: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ITEMS:
      return update(state, {
        getItems: {
          isFetching: { $set: false },
        },
        data: { $set: action.data },
      });

    case A.ERROR_GET_ITEMS:
      return update(state, {
        getItems: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ITEM_BY_ID:
      return update(state, {
        getItemById: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ITEM_BY_ID:
      return update(state, {
        getItemById: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ITEM_BY_ID:
      return update(state, {
        getItemById: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_ITEM:
      return update(state, {
        addItem: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_ITEM:
      return update(state, {
        addItem: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_ITEM:
      return update(state, {
        addItem: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_IMAGE:
      return update(state, {
        addImage: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_IMAGE:
      return update(state, {
        addImage: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_IMAGE:
      return update(state, {
        addImage: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_REORDER_IMAGE:
      return update(state, {
        reorderImage: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_REORDER_IMAGE:
      return update(state, {
        reorderImage: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_REORDER_IMAGE:
      return update(state, {
        reorderImage: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_IMAGE:
      return update(state, {
        deleteImage: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_IMAGE:
      return update(state, {
        deleteImage: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_IMAGE:
      return update(state, {
        deleteImage: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GENERATE_VARIANTS:
      return update(state, {
        generateVariants: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GENERATE_VARIANTS:
      return update(state, {
        generateVariants: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GENERATE_VARIANTS:
      return update(state, {
        generateVariants: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_EDIT_VARIANT:
      return update(state, {
        editVariant: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_EDIT_VARIANT:
      return update(state, {
        editVariant: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_EDIT_VARIANT:
      return update(state, {
        editVariant: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_VARIANT:
      return update(state, {
        deleteVariant: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_VARIANT:
      return update(state, {
        deleteVariant: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_VARIANT:
      return update(state, {
        deleteVariant: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_EDIT_ITEM:
      return update(state, {
        editItem: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_EDIT_ITEM:
      return update(state, {
        editItem: {
          isFetching: { $set: false },
        },
        // data: {$apply: i => i.map(item => {
        // 	if(item.id !== action.data.id) return item;
        // 	return action.data
        // })},
      });

    case A.ERROR_EDIT_ITEM:
      return update(state, {
        editItem: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_COPY_ITEM:
      return update(state, {
        copyItem: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_COPY_ITEM:
      return update(state, {
        copyItem: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_COPY_ITEM:
      return update(state, {
        copyItem: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ARCHIVE_ITEM:
      return update(state, {
        archiveItem: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ARCHIVE_ITEM:
      return update(state, {
        archiveItem: {
          isFetching: { $set: false },
        },
        data: {
          $apply: (i) =>
            i.filter((item) => {
              return item.id !== action.data.item.id;
            }),
        },
        archive: { $push: [action.data.item] },
      });

    case A.ERROR_ARCHIVE_ITEM:
      return update(state, {
        archiveItem: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_RESTORE_ITEM:
      return update(state, {
        restoreItem: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_RESTORE_ITEM:
      return update(state, {
        restoreItem: {
          isFetching: { $set: false },
        },
        data: { $push: [action.data.item] },
        archive: {
          $apply: (i) =>
            i.filter((item) => {
              return item.id !== action.data.item.id;
            }),
        },
      });

    case A.ERROR_RESTORE_ITEM:
      return update(state, {
        restoreItem: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_HIDESHOW_ITEM:
      return update(state, {
        hideShowItem: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_HIDESHOW_ITEM:
      return update(state, {
        hideShowItem: {
          isFetching: { $set: false },
        },
        data: {
          $apply: (i) =>
            i.map((item) => {
              if (item.id !== action.data.id) return item;
              return action.data;
            }),
        },
      });

    case A.ERROR_HIDESHOW_ITEM:
      return update(state, {
        hideShowItem: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_FEATURES:
      return update(state, {
        getFeatures: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_FEATURES:
      return update(state, {
        getFeatures: {
          isFetching: { $set: false },
        },
        features: { $set: action.data },
      });

    case A.ERROR_GET_FEATURES:
      return update(state, {
        getFeatures: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_FEATURE:
      return update(state, {
        addFeature: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_FEATURE:
      return update(state, {
        addFeature: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_FEATURE:
      return update(state, {
        addFeature: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ATTRIBUTES:
      return update(state, {
        getAttributes: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ATTRIBUTES:
      return update(state, {
        getAttributes: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ATTRIBUTES:
      return update(state, {
        getAttributes: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_ATTRIBUTE:
      return update(state, {
        addAttribute: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_ATTRIBUTE:
      return update(state, {
        addAttribute: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_ATTRIBUTE:
      return update(state, {
        addAttribute: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ADDITIONAL_DESCS:
      return update(state, {
        getAdditionalDescs: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ADDITIONAL_DESCS:
      return update(state, {
        getAdditionalDescs: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ADDITIONAL_DESCS:
      return update(state, {
        getAdditionalDescs: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_EXPORT_ITEMS_TO_FULFILLMENT:
      return update(state, {
        exportItemsToFulfillment: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_EXPORT_ITEMS_TO_FULFILLMENT:
      return update(state, {
        exportItemsToFulfillment: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_EXPORT_ITEMS_TO_FULFILLMENT:
      return update(state, {
        exportItemsToFulfillment: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PRODUCT_APPEARANCE:
      return update(state, {
        getProductAppearance: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PRODUCT_APPEARANCE:
      return update(state, {
        getProductAppearance: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_PRODUCT_APPEARANCE:
      return update(state, {
        getProductAppearance: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PRODUCT_APPEARANCE:
      return update(state, {
        updateProductAppearance: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PRODUCT_APPEARANCE:
      return update(state, {
        updateProductAppearance: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PRODUCT_APPEARANCE:
      return update(state, {
        updateProductAppearance: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PRODUCT_REVIEWS:
      return update(state, {
        getProductReviews: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PRODUCT_REVIEWS:
      return update(state, {
        getProductReviews: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_PRODUCT_REVIEWS:
      return update(state, {
        getProductReviews: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PRODUCT_REVIEW:
      return update(state, {
        updateProductReview: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PRODUCT_REVIEW:
      return update(state, {
        updateProductReview: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PRODUCT_REVIEW:
      return update(state, {
        updateProductReview: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_SUBSCRIPTION_DATA:
      return update(state, {
        getSubscriptionData: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_SUBSCRIPTION_DATA:
      return update(state, {
        getSubscriptionData: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_SUBSCRIPTION_DATA:
      return update(state, {
        getSubscriptionData: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_IMPORT_SUBSCRIPTION_DATA:
      return update(state, {
        importSubscriptionData: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_IMPORT_SUBSCRIPTION_DATA:
      return update(state, {
        importSubscriptionData: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_IMPORT_SUBSCRIPTION_DATA:
      return update(state, {
        importSubscriptionData: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ACCOUNTING_ATTRIBUTES:
      return update(state, {
        getAccountingAttributes: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ACCOUNTING_ATTRIBUTES:
      return update(state, {
        getAccountingAttributes: {
          isFetching: { $set: false },
        },
        accountingAttributes: { $set: action.data },
      });

    case A.ERROR_GET_ACCOUNTING_ATTRIBUTES:
      return update(state, {
        getAccountingAttributes: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ADD_ACCOUNTING_ATTRIBUTE:
      return update(state, {
        addAccountingAttribute: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ADD_ACCOUNTING_ATTRIBUTE:
      return update(state, {
        addAccountingAttribute: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ADD_ACCOUNTING_ATTRIBUTE:
      return update(state, {
        addAccountingAttribute: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_SKU_SETS:
      return update(state, {
        getSKUSets: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_SKU_SETS:
      return update(state, {
        getSKUSets: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_SKU_SETS:
      return update(state, {
        getSKUSets: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PHYSICAL_SET:
      return update(state, {
        updatePhysicalSet: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PHYSICAL_SET:
      return update(state, {
        updatePhysicalSet: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PHYSICAL_SET:
      return update(state, {
        updatePhysicalSet: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_SKU_SET:
      return update(state, {
        updateSKUSet: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_SKU_SET:
      return update(state, {
        updateSKUSet: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_SKU_SET:
      return update(state, {
        updateSKUSet: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PHYSICAL_SET_ORDERS:
      return update(state, {
        getPhysicalSetOrders: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PHYSICAL_SET_ORDERS:
      return update(state, {
        getPhysicalSetOrders: {
          isFetching: { $set: false },
        },
        physicalSetOrders: { $set: action.data },
      });

    case A.ERROR_GET_PHYSICAL_SET_ORDERS:
      return update(state, {
        getPhysicalSetOrders: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PHYSICAL_SET_ORDER:
      return update(state, {
        updatePhysicalSetOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PHYSICAL_SET_ORDER:
      return update(state, {
        updatePhysicalSetOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PHYSICAL_SET_ORDER:
      return update(state, {
        updatePhysicalSetOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_COPY_PHYSICAL_SET_ORDER:
      return update(state, {
        copyPhysicalSetOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_COPY_PHYSICAL_SET_ORDER:
      return update(state, {
        copyPhysicalSetOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_COPY_PHYSICAL_SET_ORDER:
      return update(state, {
        copyPhysicalSetOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_CANCEL_PHYSICAL_SET_ORDER:
      return update(state, {
        cancelPhysicalSetOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_CANCEL_PHYSICAL_SET_ORDER:
      return update(state, {
        cancelPhysicalSetOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_CANCEL_PHYSICAL_SET_ORDER:
      return update(state, {
        cancelPhysicalSetOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ESHOPS:
      return update(state, {
        getEshops: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ESHOPS:
      return update(state, {
        getEshops: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ESHOPS:
      return update(state, {
        getEshops: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PRODUCTS_HISTORY:
      return update(state, {
        getProductHistory: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PRODUCTS_HISTORY:
      return update(state, {
        getProductHistory: {
          isFetching: { $set: false },
        },
        productHistory: { $set: action.data },
      });

    case A.ERROR_GET_PRODUCTS_HISTORY:
      return update(state, {
        getProductHistory: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_PRODUCTS_HISTORY_DIFF:
      return update(state, {
        productsDifHistory: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_PRODUCTS_HISTORY_DIFF:
      return update(state, {
        productsDifHistory: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_PRODUCTS_HISTORY_DIFF:
      return update(state, {
        productsDifHistory: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_PRODUCTS_BATCH_ACCOUNTING_STOCKS:
      return update(state, {
        productsBatchAccountingStocks: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_PRODUCTS_BATCH_ACCOUNTING_STOCKS:
      return update(state, {
        productsBatchAccountingStocks: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_PRODUCTS_BATCH_ACCOUNTING_STOCKS:
      return update(state, {
        productsBatchAccountingStocks: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_PRODUCTS_WAREHOUSE_CATEGORIES:
      return update(state, {
        productsWarehouseCategories: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_PRODUCTS_WAREHOUSE_CATEGORIES:
      return update(state, {
        productsWarehouseCategories: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_PRODUCTS_WAREHOUSE_CATEGORIES:
      return update(state, {
        productsWarehouseCategories: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PRODUCTS_PRICE_MARGIN_HISTORY:
      return update(state, {
        getProductsPriceMarginHistory: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PRODUCTS_PRICE_MARGIN_HISTORY:
      return update(state, {
        getProductsPriceMarginHistory: {
          isFetching: { $set: false },
        },
        productsPriceMarginHistory: { $set: action.data },
      });

    case A.RESET_GET_PRODUCT_PRICE_MARGIN_HISTORY:
      return update(state, {
        productsPriceMarginHistory: { $set: action.data },
      });

    case A.ERROR_GET_PRODUCTS_PRICE_MARGIN_HISTORY:
      return update(state, {
        getProductsPriceMarginHistory: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PRODUCT_MARGIN:
      return update(state, {
        getProductMargin: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PRODUCT_MARGIN_DELIVERED:
      return update(state, {
        getProductMarginDelivered: {
          isFetching: { $set: false },
        },
        productMarginDelivered: { $set: action.data },
      });

    case A.RECEIVE_GET_PRODUCT_MARGIN_SHIPPED:
      return update(state, {
        getProductMarginShipped: {
          isFetching: { $set: false },
        },
        productMarginShipped: { $set: action.data },
      });

    case A.RESET_GET_PRODUCT_MARGIN:
      return update(state, {
        productMarginShipped: { $set: action.data },
        productMarginDelivered: { $set: action.data },
      });

    case A.ERROR_GET_PRODUCT_MARGIN:
      return update(state, {
        getProductMargin: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL:
      return update(state, {
        importChestnyznakUniqNumbersExcel: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL:
      return update(state, {
        importChestnyznakUniqNumbersExcel: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_IMPORT_CHESTNYZNAK_UNIQ_NUMBERS_EXCEL:
      return update(state, {
        importChestnyznakUniqNumbersExcel: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_STATISTICS_OF_USING_CHESTNYZNAK:
      return update(state, {
        getStatisticsOfUsingChestnyznak: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_STATISTICS_OF_USING_CHESTNYZNAK:
      return update(state, {
        getStatisticsOfUsingChestnyznak: {
          isFetching: { $set: false },
        },
        statisticsOfUsingChestnyznak: { $set: action.data },
      });

    case A.ERROR_STATISTICS_OF_USING_CHESTNYZNAK:
      return update(state, {
        getStatisticsOfUsingChestnyznak: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK:
      return update(state, {
        getUnloadingSetOfGoodsChestnyznak: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK:
      return update(state, {
        getUnloadingSetOfGoodsChestnyznak: {
          isFetching: { $set: false },
        },
        statisticsOfUsingChestnyznak: { $set: action.data },
      });

    case A.ERROR_GET_UNLOADING_SET_OF_GOODS_CHESTNYZNAK:
      return update(state, {
        getUnloadingSetOfGoodsChestnyznak: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_STOCK_BY_DATE:
      return update(state, {
        getStockByDate: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_STOCK_BY_DATE:
      return update(state, {
        getStockByDate: {
          isFetching: { $set: false },
        },
        stockByDate: { $set: action.data },
      });

    case A.ERROR_GET_STOCK_BY_DATE:
      return update(state, {
        getStockByDate: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default items;
